import React from "react";

/**
 * Alert container, supports variants: 'default' or 'destructive'.
 * Usage:
 * <Alert variant="destructive">
 *   <AlertCircle className="h-4 w-4" />
 *   <AlertTitle>Erreur</AlertTitle>
 *   <AlertDescription>Message d'erreur</AlertDescription>
 * </Alert>
 */
export function Alert({
  variant = "default",
  children,
  className = "",
  ...props
}) {
  const baseStyles = "p-4 border rounded flex items-start space-x-2";
  const variantStyles = {
    default: "bg-blue-50 border-blue-200 text-blue-800",
    destructive: "bg-red-50 border-red-200 text-red-800",
  };
  const appliedVariant = variantStyles[variant] || variantStyles.default;

  return (
    <div className={`${baseStyles} ${appliedVariant} ${className}`} {...props}>
      {children}
    </div>
  );
}

/**
 * Title for an Alert.
 * Renders bold text.
 */
export function AlertTitle({ children, className = "", ...props }) {
  return (
    <h5 className={`font-semibold ${className}`} {...props}>
      {children}
    </h5>
  );
}

/**
 * Description for an Alert.
 * Renders normal paragraph text.
 */
export function AlertDescription({ children, className = "", ...props }) {
  return (
    <p className={`${className}`} {...props}>
      {children}
    </p>
  );
}
